export const safariUIBgColor = {
    AUTO: 'auto',
    TRANSPARENT: 'transparent',
    GREY: '#1a1919',
    DARK_GREY: '#0d0c0c',
    LIGHT_GREY: '#7f7f7f',
    WHITE: '#ffffff',
};

const applyColor = (el, color) => {
    if (color === safariUIBgColor.TRANSPARENT) {
        el.classList.add('bg-transparent');
        el.style.backgroundColor = el.id === 'topbar' ? safariUIBgColor.WHITE : '';
    } else {
        el.classList.remove('bg-transparent');
        el.style.backgroundColor = color;
    }
};

export const setSafariUIBgColors = (topBgColor = safariUIBgColor.AUTO, bottomBgColor = safariUIBgColor.AUTO) => {
    const topbar = document.getElementById('topbar');
    const bottombar = document.getElementById('bottombar');
    if (!topbar || !bottombar) return;

    if (topBgColor === safariUIBgColor.AUTO) {
        const headerTop = document.getElementById('header-top');
        const headerTopHeight = headerTop ? headerTop.offsetHeight : 0;
        if (headerTopHeight > 0 && window.scrollY < headerTopHeight) {
            applyColor(topbar, safariUIBgColor.GREY);
        } else {
            applyColor(topbar, safariUIBgColor.WHITE);
        }
    } else {
        applyColor(topbar, topBgColor);
    }

    if (bottomBgColor === safariUIBgColor.AUTO) {
        const remaining = document.documentElement.scrollHeight - window.scrollY - window.innerHeight;
        if (remaining < 5) {
            applyColor(bottombar, safariUIBgColor.GREY);
        } else {
            applyColor(bottombar, safariUIBgColor.TRANSPARENT);
        }
    } else {
        applyColor(bottombar, bottomBgColor);
    }
};

// drawer 닫힘 트랜지션(0.35s, styles.css.liquid #offcanvas/#dropdown-cart, cp.css .mycp-container)이
// 끝난 뒤에 색을 바꾼다. 그 사이 다시 열렸으면 isReopened()가 true를 반환해 건너뛴다.
// (assets/ajax.jquery.js closeDrawer 의 필터 drawer 패턴과 동일.)
const DRAWER_CLOSE_TRANSITION_MS = 380;
export const setSafariUIBgColorsAfterClose = (
    isReopened,
    topBgColor = safariUIBgColor.AUTO,
    bottomBgColor = safariUIBgColor.AUTO,
) => {
    setTimeout(() => {
        if (typeof isReopened === 'function' && isReopened()) return;
        setSafariUIBgColors(topBgColor, bottomBgColor);
    }, DRAWER_CLOSE_TRANSITION_MS);
};

window.safariUIBgColor = safariUIBgColor;
window.setSafariUIBgColors = setSafariUIBgColors;
window.setSafariUIBgColorsAfterClose = setSafariUIBgColorsAfterClose;
